<template>
  <div class="main">
    <div class="wrapper">
      <h3>地址：北京市海淀区清河嘉园西区1号</h3>
      <h3>邮编：100080</h3>
      <h3>电话：010-53612925</h3>
      <h3>移动电话：18500567137</h3>
      <h3>邮箱：bjtwzyy2017@163.com</h3>
      <h3>工作时间：9:00-18:00</h3>
      <div class="map">
        <el-amap vid="amapDemo" :center="center" :zoom="zoom" class="amap-demo" :events="events">
          <el-amap-marker
            :position="marker.position"
            :events="marker.events"
            :visible="marker.visible"
            :draggable="marker.draggable"
          ></el-amap-marker>
        </el-amap>
      </div>
    </div>
  </div>
</template>
<script>
import { add } from "@/api/litter";
import Bus from "@/utils/bus.js";
export default {
  data() {
    let self = this;
    return {
      zoom: 14,
      center: [116.349634,40.03402],
      searchOption: {
        city: "全国",
        citylimit: true
      },
      marker: {
        position: [116.349634,40.03402]
      },
      address: "",
      events: {
        click(e) {
          let { lng, lat } = e.lnglat;
          self.lng = lng;
          self.lat = lat;
          self.marker.position = [lng, lat];
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all"
          });
          geocoder.getAddress([lng, lat], function(status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress;
                self.$nextTick();
              }
            }
          });
        }
      },
      lng: 0,
      lat: 0,
      nav: [
        { title: "联系方式", url: "lxfs" },
        { title: "加入我们", url: "jrwm" },
        { title: "留言板", url: "lyb" }
      ]
    };
  },
  mounted() {
    // window.scrollTo(0, 0);
  },
  methods: {},
  components: {
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 20px;
  .wrapper {
    width: calc(100vw - 60px);
    margin: 20px auto 60px;
    h3 {
      line-height: 50px;
      color: #000;
      font-size: 28px;
      height: 50px;
    }
    .map {
      width: 100%;
      height: 400px;
      margin-top: 10px;
    }
  }
}
</style>